import { api } from './client';

/** ч.972: довідковий центр. Публічне API — працює і без логіну. */
export interface HelpSection {
  section: string;
  count: number;
}

export interface HelpArticleListItem {
  id: string;
  slug: string;
  section: string;
  title: string;
  summary: string;
  route_pattern: string | null;
  /** ч.1420: вид матеріалу. */
  kind?: string | null;
}

export interface HelpArticle extends HelpArticleListItem {
  body_md: string;
  faq: { question: string; answer: string }[];
  tags: string[];
  updated_at: string | null;
  /** ч.1429: схожі статті розділу і сторінка про цю ділянку (її показуємо гостю) */
  related?: { slug: string; title: string }[];
  landing?: { key: string; path: string; label: string } | null;
}

/** ч.1116: статті, повʼязані зі сторінкою (кнопка «як це працює»). */
export interface HelpPageArticles {
  /** Шаблон маршруту сторінки; null — статті про неї ще немає. */
  route: string | null;
  items: HelpArticleListItem[];
  total: number;
  /** ч.1319: опублікована відео-інструкція сторінки (YouTube); null — ролика немає. */
  video_url?: string | null;
  /** ч.1327: ролики-сценарії і відповіді на питання, що проходять цією сторінкою. */
  videos?: { title: string; url: string; kind: 'TOPIC' | 'FAQ' }[];
}

export const help = {
  sections: () => api.get<HelpSection[]>('/help/sections').then((r) => r.data),

  /** Довідка про сторінку за її адресою (шлях і параметри, як у браузері):
   *  стаття сторінки, її списку/картки і пункту меню — у порядку показу. */
  pageArticles: (path: string) =>
    api.get<HelpPageArticles>('/help/page-articles', { params: { path } }).then((r) => r.data),

  articles: (params: { section?: string; q?: string; route?: string } = {}) =>
    api.get<HelpArticleListItem[]>('/help/articles', { params }).then((r) => r.data),

  article: (slug: string) =>
    api.get<HelpArticle | null>(`/help/articles/${encodeURIComponent(slug)}`)
      .then((r) => r.data),

  feedback: (slug: string, helpful: boolean) =>
    api.post('/help/feedback', { slug, helpful },
      // Фонова телеметрія — без системних тостів.
      { headers: { 'X-Silent-Toast': '1' } }).then(() => undefined),

  /** Журнал пошуків: запити БЕЗ результату показують, якої статті бракує. */
  logSearch: (query: string, found: boolean, route_pattern?: string | null) =>
    api.post('/help/search-log', { query, found, route_pattern: route_pattern ?? null },
      { headers: { 'X-Silent-Toast': '1' } }).then(() => undefined).catch(() => undefined),
};

export default help;
